import React from 'react';

/**
 * Shared error state component
 * @param {string} message - Error message to display
 * @param {string} className - Additional CSS classes
 */
function ErrorState({ message = 'An error occurred', className = '' }) {
  return (
    <div className={`error ${className}`}>
      {message}
    </div>
  );
}

export default ErrorState;
